import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from "@angular/core";
import {VenueContactData} from "./venue-contact.data";
import {VenueContactService} from "./venue-contact.service";
import {FormGroup} from "@angular/forms";
import {ErrorHandlerService} from "../../../error-handler.service";
import {CustomerInstanceVenueModel} from "../customer-instance-venue.model";
import {Subscription} from "rxjs";

@Component({
    selector: "fhm-venue-contact",
    styles: [":host {display: flex; width: 100%;}"],
    templateUrl: "./venue-contact.component.html",
    styleUrls: ["./venue-contact.component.scss"],
    providers: [VenueContactService],
    standalone: false
})
export class VenueContactComponent implements OnInit, OnDestroy {

    data: VenueContactData;

    editing: boolean;

    subscription: Subscription = new Subscription();

    @Input() formGroupContact: FormGroup;
    @Input() contactId: string;
    @Input() label: string;

    constructor(private errorHandler: ErrorHandlerService,
                public model: CustomerInstanceVenueModel,
                private changeDetectorRef: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        this.subscription.add(this.model.data$.subscribe(() => {
            this.changeDetectorRef.detectChanges();
            if (this.contactId === VenueContactData.PRIMARY_SITE_ID) {
                this.data = this.model.draft ? this.model.data.siteContact : Object.assign({}, this.model.data.siteContact);
            } else {
                this.data = this.model.draft ? this.model.data.primaryContact : Object.assign({}, this.model.data.primaryContact);
            }
            this.editing = this.model.draft || this.newEntity;
        }));
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    async save(): Promise<void> {
        if (this.formGroupContact.valid) {
            try {
                await this.model.saveContact(this.data);
                this.editing = false;
            } catch (e) {
                this.errorHandler.handleErrorResponse(e);
            }
        }
    }

    edit(): void {
        this.editing = true;
    }

    cancelEdit(): void {
        if (this.contactId === VenueContactData.PRIMARY_SITE_ID) {
            this.data = Object.assign({}, this.model.data.siteContact);
        } else {
            this.data = Object.assign({}, this.model.data.primaryContact);
        }
        this.editing = false;
    }

    get newEntity(): boolean {
        return !this.data.id;
    }
}
